import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { DocumentiSearchDocRow } from 'src/app/shared/models/documento-search.model';
import { HeaderDeclassificaOperazioniMassive } from '../models/operazioni-massive.model';
import { OperazioniMassiveService } from '../services/operazioni-massive.service';

@Component({
  selector: 'app-riepilogo-declassifica',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="grid ">
      <div class="col-4">
        <p-card class="ml-2">
          <p class="m-0">Nuova classifica: <span class= "font-bold">{{header()?.classifica?.nomeClassifica}}</span></p>
          <p class="m-0">Data declassifica: <span class="font-bold">{{header()?.dataDeclassifica | date: 'dd/MM/yyyy'}}</span></p>
          <p class="m-0">Note: <span class="font-bold">{{noteToShow()}}</span></p>
          <p class="m-0">Vietata la divulgazione: <span class="font-bold">{{(header()?.vietataDivulgazione)?'Si':'No'}}</span></p>
        </p-card>
      </div>
      <div class="col-12">
        <p-table [value]="items()" styleClass="p-datatable-gridlines">
          <ng-template pTemplate="header">
              <tr>
                  <th class="text-center w-1">Qualifica e classifica di segretezza del documento</th>
                  <th class="text-center w-2">Numero di protocollo o di controllo del documento</th>
                  <th class="text-center w-3">Oggetto del documento</th>
                  <th class="text-center w-1">Data del Documento</th>
                  <th class="text-center w-1">Lingua in cui il documento è redatto</th>
                  <th class="text-center w-1">Stato del Documento</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
              <tr>
                  <td class="text-center">{{ item.classifica }} {{ item.qualifica }}</td>
                  <td class="text-center">{{ item.protocollo }}</td>
                  <td class="text-center">{{ item.oggetto }}</td>
                  <td class="text-center">{{ item.dataDocumento | date: "dd/MM/yyyy" }}</td>
                  <td class="text-center">{{ item.lingua }}</td>
                  <td class="text-center">{{ item.stato }}</td>
              </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="col-12 buttons flex justify-content-end gap-2">
        <button *ngIf="!showOnly()" pButton type="button" icon="fas fa-file-download" label="Conferma" title="Conferma" (click)="confirmUnClassified()"></button>
      </div>
    </div>
  `
})
export class RiepilogoDeclassificaComponent {

  private readonly confirmationService = inject(ConfirmationService);
  private readonly messageService = inject(MessageService);

  private readonly operazioniMassiveService = inject(OperazioniMassiveService);

  header = input<HeaderDeclassificaOperazioniMassive | undefined>();
  items = input<DocumentiSearchDocRow[]>([]);
  showOnly = input<boolean>(false);
  // @Input() showOnly? = true;

  public noteToShow = computed(() => {
    const header = this.header();
    if (header)
      return (header.nota.length <= 64) ? header.nota : `${header.nota.substring(0, 64)}...`;

    return '';
  });

  private doUnClassified(): void {

    const header = this.header();

    if (header)
      this.operazioniMassiveService.declassifica(header, this.items())
        .subscribe((res) => {
          let message: Message = { severity: 'success', summary: 'Declassifica Massiva Documenti', detail: 'Operazione completata con successo' };

          if (!res) {
            message = { severity: 'error', summary: 'Errore', detail: 'Errore nella operazione di declassifica massiva dei documenti selezionati' };
          }
          this.messageService.add(message);
        });
  }

  public confirmUnClassified(): void {

    this.confirmationService.confirm({
      message: 'Sei sicuro di voler procedere alla declassificazione dei documenti selezionati?',
      header: 'Declassifica Massiva di Documenti',
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.doUnClassified(),
      //reject: () => this.cancelUnClassified()
    });
  }

}
